import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./site.css";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import LegalPage from "./pages/LegalPage";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/legal" element={<LegalPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
